// TODO support nested object
// ref: AdminDetail.js items.isSampleItem

import type { Diff } from './order-diff-utils';

export default function setDiffsHelper(
  scope: string,
  newValue: unknown,
  diffs: Diff[],
  setDiffs: (diffs: Diff[]) => void,
) {
  const find = diffs.find((d) => d.scope === scope);
  if (find) {
    find.data = newValue;
  } else {
    setDiffs([
      ...diffs,
      {
        event: 'set',
        scope,
        data: newValue,
      },
    ]);
  }
}

